import { useEffect, useState } from 'react';
import { Image as ImageIcon } from '../../../icons';
import { requestPresignedDownload } from '../../../api/files';

/**
 * 목록 썸네일 (2026-08-19).
 *
 * 첨부 이미지를 presigned URL 로 받아 그린다 — 채팅 미디어 패널이 쓰는 것과 같은 경로다
 * (`requestPresignedDownload` → `<img loading="lazy">`).
 *
 * URL 이 오기 전과 실패한 뒤에는 **자리를 유지한 채** 아이콘만 둔다. 그림이 늦게 와서 카드
 * 높이가 튀면 목록 전체가 흔들리기 때문이다.
 */
interface BoardThumbProps {
  fileId: string;
  name: string;
}

export function BoardThumb({ fileId, name }: BoardThumbProps) {
  const [url, setUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setUrl(null);
    setFailed(false);
    requestPresignedDownload(fileId, { disposition: 'inline', purpose: 'preview' }) // 썸네일 = 「열람」(§3.4.1)
      .then((res) => { if (!cancelled) setUrl(res.downloadUrl); })
      .catch(() => { if (!cancelled) setFailed(true); });
    return () => { cancelled = true; };
  }, [fileId]);

  if (!url || failed) {
    return (
      <span className="bdw-thumb bdw-thumb--empty" aria-hidden>
        <ImageIcon size={18} />
      </span>
    );
  }
  return (
    <span className="bdw-thumb">
      <img src={url} alt={name} loading="lazy" onError={() => setFailed(true)} />
    </span>
  );
}
